import { FC } from 'react';
import { Button } from 'src/components/buttons-and-actions/button';
import { Stack } from 'src/components/layout/stack';
import { Modal } from 'src/components/overlay/modal';

const DowngradePrismaApiModal: FC<{ onDismiss: () => void }> = ({
  onDismiss,
}) => {
  return (
    <Modal
      title="Are you sure you want to stop using the PRISMA API?"
      onDismiss={() => onDismiss()}
    >
      <p>
        We will assist you in the offboarding - for this, please reach out to
        our Customer Success team (
        <a href="mailto:helpdesk@prisma-capacity.eu">
          helpdesk@prisma-capacity.eu
        </a>
        ).
      </p>
      <Stack gap={1} flow="column" textAlign="right">
        <div>
          <Button mode="primary" onClick={() => onDismiss()}>
            OK
          </Button>
        </div>
      </Stack>
    </Modal>
  );
};

export default DowngradePrismaApiModal;
